import React from "react";
import { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
function Plan() {
  const { cliente, cursoscomprados, traemeColorClub, colorClub } =
    useContext(Contexto);

  const [tuColorClub, setTuColorClub] = useState(false);

  useEffect(() => {
    if (cursoscomprados.hasOwnProperty("color-club")) {
      setTuColorClub(cursoscomprados["color-club"]);
    } else {
      setTuColorClub(false);
    }
  }, [cursoscomprados]);

  let handleClick = () => {};
  return (
    <>
      <div className="soporteLogin">
        <div className="login">
          {tuColorClub && (
            <div className="login__wrapper ">
              <p className="titFelicitaciones">Tu acceso al Club</p>
              Días restantes: {tuColorClub.restantes} <br />
              <br />
              <p>Si querés cancelar tu suscripción mensual:</p>
              <button className="formuBT" onClick={handleClick}>
                CANCELAR SUSCRIPCIÓN
              </button>
              <br />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Plan;
